import * as types from './action-types';

export const updateStart = values => (
  {type: types.UPDATE_START, values}
);

export const setSocialSharing = values => (
  {type: types.SET_SOCIAL_SHARING, values}
);

export const setOrderComplete = values => (
  {type: types.SET_ORDER_COMPLETE, values}
);
